export enum Object3DType {
  OBJECT_UI = 'object_ui',
  CANVAS_OBJECT = 'canvas-object',
}

export interface BaseObjectUserData {
  objectType: Object3DType;
}
